import React, { forwardRef } from "react";
import MuiTooltip, { type TooltipProps } from "@material-ui/core/Tooltip";

import Popper from "./Popper";

export type { TooltipProps };

/** This is just a wrapper of Mui's Tooltip that patches `PopperComponent` property to make
 * the tooltip work in fullscreen mode.
 */
const Tooltip = forwardRef((props: TooltipProps, ref) => (
  <MuiTooltip ref={ref} PopperComponent={Popper} {...props} />
));

export default Tooltip;
